export default "__VITE_ASSET__Bt796soL__"